import { useMemo } from "react";
import { withNamespaces } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import Navigator from "src/components/Navigator";
import Tabs from "./components/tabs";
import Geocledian from "./components/geocledian";
import Companyinfo from "./components/companyinfo";
import Dnb from "./components/dnb";

const LicenseManagement = ({ t }) => {
    const location = useLocation();

    const renderSelectedTabContent = () => {
        const searchParams = new URLSearchParams(location.search);

        switch (searchParams.get("tab")) {
            case "geocledian":
                return (
                    <Geocledian />
                )

            case "companyinfo":
                return (
                    <Companyinfo />
                )

            case "dnb":
                return (
                    <Dnb />
                )

            default:
                return null
        }
    };

    const navigatorOptions = useMemo(() => {
        return {
            translate: false,
            backButtonOptions: () => {
                return {
                    enable: false,
                    title: t("Back"),
                    icon: <i className="ri-arrow-left-fill"></i>
                }
            },
            breadCrumbs: [
                {
                    title: t("SIP"),
                    link: "/admin/3rd-party/dashboard"
                },
                {
                    title: t("{{creditLabel}} Management", {
                        creditLabel: 'Credit'
                    }),
                    link: "/admin/3rd-party/administration/license"
                }
            ],
            pageTitle: t("{{creditLabel}} Management", {
                creditLabel: 'Credit'
            })
        }
    }, [ t ]);

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator {...navigatorOptions} />
                    </Col>

                    <Col lg="12" className="mb-4">
                        <div className="details-content-wrapper">
                            <Tabs />

                            <Row>
                                <Col xl="12">
                                    {renderSelectedTabContent()}
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default withNamespaces()(
    LicenseManagement
);